import { from, of } from 'rxjs'
import { catchError, filter, map, mergeMap, switchMap } from 'rxjs/operators'
import { RootEpic } from '~/Store/types'
import { errorNotification } from '~/Services'
import { RolesActions } from './slice'
import { RolesService } from '~/Services/AdminRolesService'
import { UserService } from '~/Services/AdminUsers'
import { successNotification } from '~/Services/utils'

const getAllRoles: RootEpic = (action$, state$) =>
  action$.pipe(
    filter(RolesActions.getRolesRequest.match),
    switchMap(() => {
      return from(RolesService.Get.getAllRoles()).pipe(
        map(res => RolesActions.setRolesSuccess(res.data)),
        catchError(error => {
          errorNotification(error)
          return of(RolesActions.setRolesError())
        }),
      )
    }),
  )

export const getUserRolesEpic: RootEpic = action$ =>
  action$.pipe(
    filter(RolesActions.getUserRolesRequest.match),
    mergeMap(action => {
      const userId = action.payload
      return from(UserService.Get.getRolesToUserId(userId)).pipe(
        map(res => RolesActions.getUserRolesSuccess(res.data)),
        catchError(error => {
          errorNotification(error)
          return of(
            RolesActions.getUserRolesFailure(
              error.message || 'Lỗi khi lấy danh sách vai trò',
            ),
          )
        }),
      )
    }),
  )

const updateRoleEpic: RootEpic = action$ =>
  action$.pipe(
    filter(RolesActions.updateRoleRequest.match),
    switchMap(action => {
      const payload = action.payload
      return from(RolesService.Put.updateRolesInfo(payload)).pipe(
        map(res => RolesActions.updateRoleSuccess(res.data)),
        catchError(error => {
          errorNotification(error)
          return of(RolesActions.updateRoleError())
        }),
      )
    }),
  )

const deleteRoles: RootEpic = action$ =>
  action$.pipe(
    filter(RolesActions.deleteRoleRequest.match),
    switchMap(({ payload }) =>
      from(RolesService.Delete.removeRoles(payload)).pipe(
        map(() => {
          return RolesActions.deleteRoleSuccess(payload)
        }),
        catchError(error => {
          errorNotification(error)
          return [RolesActions.deleteRoleError()]
        }),
      ),
    ),
  )

const updateRolesUserEpic: RootEpic = action$ =>
  action$.pipe(
    filter(RolesActions.updateUserRoles.match),
    mergeMap(action => {
      const { userId, roleName } = action.payload
      //console.log('Updating roles for user:', action.payload)
      return from(UserService.Put.updateRolesUser(userId, { roleName })).pipe(
        map(() => {
          successNotification('Cập nhật vai trò thành công!')
          return RolesActions.getUserRolesRequest(userId)
        }),
        catchError(error => {
          errorNotification(error)
          return of(
            RolesActions.updateUserRoleFailure(
              error.message || 'Error updating user role',
            ),
          )
        }),
      )
    }),
  )

const deleteUserRoleEpic: RootEpic = action$ =>
  action$.pipe(
    filter(RolesActions.deleteUserRolesRequest.match),
    mergeMap(action => {
      const { userId, roleName } = action.payload
      return from(
        UserService.Delete.deleteRolesUser(userId, roleName), // gửi mảng chuỗi
      ).pipe(
        map(() => {
          successNotification(
            `Xóa vai trò "${roleName.join(', ')}" thành công!`,
          )
          return [
            //RolesActions.deleteUserRolesSuccess({ userId, roleName }),
            RolesActions.getUserRolesRequest(userId),
          ]
        }),
        mergeMap(actions => from(actions)),
        catchError(error => {
          errorNotification(error)
          return of(
            RolesActions.deleteUserRolesFailure(
              error.message || 'Lỗi khi xóa vai trò người dùng',
            ),
          )
        }),
      )
    }),
  )

export const RolesEpics = [
  getAllRoles,
  updateRolesUserEpic,
  getUserRolesEpic,
  deleteUserRoleEpic,
  // addRoleEpic,
  updateRoleEpic,
  deleteRoles,
]
